import React, { PropTypes, Component } from 'react'
import constants from 'constants'
import { Progress } from '.'

class DraftPlan extends Component {
    static propTypes = {
      currentUser: PropTypes.object.isRequired,
      handleUpload: PropTypes.func.isRequired,
      selectedPlan: PropTypes.object.isRequired,
    }

    render() {
      const steps = [
        {
          key: 1,
          label: constants.PARTNERPLAN.STEPS.DRAFT,
          desc: 'Pending',
          isDone: false,
          isCurrent: true,
          actions: [
            {
              label: 'UPLOAD',
              onClick: this.props.handleUpload,
              active: true,
              show: (this.props.selectedPlan.Role === constants.PARTNERPLAN.ROLE.MYPLANS && this.props.currentUser.IsAdmin === true),
            },
          ],
        },
        {
          key: 2,
          label: constants.PARTNERPLAN.STEPS.SUBMIT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 3,
          label: constants.PARTNERPLAN.STEPS.AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 4,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 5,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_SUBMITTED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 6,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 7,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 8,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_SUBMITTED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 9,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
      ]

      return (
        <Progress steps={steps} />
      )
    }
}

export default DraftPlan



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/DraftPlan.js